const ACCESS_TOKEN_KEY_PREFIX = 'patientAccessToken:';

const buildStorageKey = (workflowId) =>
  `${ACCESS_TOKEN_KEY_PREFIX}${workflowId}`;

export const getPatientAccessToken = (workflowId) => {
  try {
    return window.sessionStorage.getItem(buildStorageKey(workflowId));
  } catch {
    return null;
  }
};

export const savePatientAccessToken = (workflowId, accessToken) => {
  try {
    window.sessionStorage.setItem(buildStorageKey(workflowId), accessToken);
  } catch {
    return;
  }
};

export const clearPatientAccessToken = (workflowId) => {
  try {
    window.sessionStorage.removeItem(buildStorageKey(workflowId));
  } catch {
    return;
  }
};

export const buildPatientAuthorizationHeader = (workflowId) => {
  const accessToken = getPatientAccessToken(workflowId);

  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
};
